import React from "react";
import * as s from "./index.module.scss";
import { Container } from "react-bootstrap";
import { PrismicLink } from "@prismicio/react";

const FeaturedOn = ({ data }) => {
  return (
    <section className={`section-center`}>
      <Container>
        <h3 className={`text-center heading fw-bold ${s.header_area}`}>
          {data?.featured_on_title || "Featured on"}
        </h3>
        <div className={s.logo_container}>
          {data?.logos.map((logo, idx) => {
            return (
              <div className={s.single_logo} key={idx}>
                {logo?.logo_url?.url ? (
                  <PrismicLink field={logo?.logo_url}>
                    <img
                      loading="lazy"
                      src={logo?.logo?.url}
                      alt={logo?.logo?.alt || "image"}
                      height="100%"
                    />
                  </PrismicLink>
                ) : (
                  <img
                    loading="lazy"
                    src={logo?.logo?.url}
                    alt={logo?.logo?.alt || "image"}
                    height="100%"
                  />
                )}
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default FeaturedOn;
